var ClinicalUpdatesService = /** @class */ (function () {
    /*@ngInject*/
    function ClinicalUpdatesService($http, Util) {
        this._$http = $http;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
    }
    /*@ngInject*/
    ClinicalUpdatesService.prototype.getClinicalUpdatesData = function () {
        var request = this._$http({
            method: "get",
            url: "/api/education/clinical-updates"
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    ClinicalUpdatesService.prototype.getBlog = function () {
        var request = this._$http({
            method: "get",
            url: "/api/content/resourceContentFile/blog"
        });
        return (request.then(function (response) {
            return response.data;
        }, this.handleError));
    };
    return ClinicalUpdatesService;
}());
export default ClinicalUpdatesService;
//# sourceMappingURL=clinical-updates.service.js.map